<section class="password-input-container">
  <span class="p-float-label">
    <p-password
      #passwordElement
      [feedback]="feedback"
      [toggleMask]="toggleMask"
      [ngClass]="{ 'p-password--isInvalid': isInvalid }"
      [(ngModel)]="passwordValue"
      (ngModelChange)="onChange()"
      (onBlur)="onBlur()"
      />
    <label
      class="label-text"
      for="passwordElement"
      [ngClass]="{ 'label-error': isInvalid, 'top-label': passwordValue }">
      {{ label }}
    </label>

    <i *ngIf="isInvalid"
      class="pi pi-exclamation-circle icon-warning label-error"></i>
    <p *ngIf="helperText" class="helper-text">{{ helperText }}</p>
    <p *ngIf="isInvalid" class="label-error label-message">{{ labelError }}</p>
  </span>
</section>
